import React from 'react'
import { MdLogout } from 'react-icons/md';
import List from './List';
import Dropdown from './Dropdown';

const ListSection = ({ list, handleNavigate, sidebarRef, open }) => {
    // Same logout as the inactivity timer in App.jsx: clear token + reload
    // (the guard redirects to login when no token is present).
    const handleLogout = () => {
        window.localStorage.clear();
        window.location.reload();
    };

    return (
        <div
            ref={sidebarRef}
            className={`absolute overflow-auto bg-gray-100 shadow-2xl drop-shadow-lg top-0 left-0 ml-0 w-[200px] z-[999] px-2 py-4 transition-all ease-in-out duration-300 transform ${open ? "translate-y-[60px]" : "-translate-y-full"
                }`}
        >
            <div className="pl-2 flex flex-col items-start justify-center w-full">
                <ul className='w-full'>
                    {list?.map((item, index) => {
                        const { Icon } = item;
                        if (item?.subMenu?.length > 0) {
                            return <Dropdown key={index} lableName={item} item={item} />
                        } else {
                            return <div key={index}>
                                <List index={index} Icon={Icon} item={item} handleNavigate={handleNavigate} />
                            </div>
                        }
                    })}
                    {/* Logout — bottom of the hamburger menu */}
                    <li
                        onClick={handleLogout}
                        className="mt-2 pt-3 border-t border-gray-300 text-black font-[500] text-[17px] px-3 py-2 laptop:text-sm laptopScreenHeight:text-sm rounded-xl flex items-center capitalize hover:opacity-40 cursor-pointer transition-all ease-out"
                    >
                        <MdLogout className="text-xl mr-3" />
                        Logout
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ListSection
